module.exports = __webpack_public_path__ + "static/media/shivani.3ad47448.jpg";